import { AnimatedApplicationLogo } from 'components/Logo/AnimatedApplicationLogo';

export function LoadingLogo() {
  return (
    <div className="m-auto" data-testid="loading-spinner">
      <AnimatedApplicationLogo />
    </div>
  );
}
